/**
 * A global namespace for the `selectstart` event.
 */
const selectstartEvent = "selectstart";
export default selectstartEvent;
